module.exports = __webpack_public_path__ + "static/kakao-right-down-bed88f33b762319a3257dc29344fa588.png";